import { SET_THEME_COLOR, SET_PAGE_TEMPLATE } from "@/store/mutation_types";
import { THEME_CONFIG, getTemplateConfig } from "@/utils/const.js";
import { ThemeIndex } from "@/constant/theme";

import { Toast } from "vant";

let themeColor = getDefPrimaryColor();
try {
  var locTheme = JSON.parse(localStorage.getItem("themeColor"));

  if (locTheme && locTheme.primaryColor) {
    themeColor = locTheme;
  }
} catch (e) {
  // 使用主题默认颜色
}
let lessNodesAppended = false;
themeColor.version = themeColor.version || "1.0.0";

function getDefPrimaryColor() {
  const tpls = getTemplateConfig();
  const cur = tpls.find(item => item.selected);
  if (cur) {
    return {
      primaryColor: cur.primaryColor
    };
  }
  return THEME_CONFIG[configText.defaultTheme || 0];
}

function getCurrentTemplate() {
  const tpls = getTemplateConfig();
  return locTheme || tpls.find(item => item.selected) || {};
}

import { less_change } from "@/utils/less";
const updateTheme = themeColor => {
  if (!themeColor) {
    return;
  }
  const hideMessage = Toast("正在加载...");
  // console.log("切换模版",themeColor);
  if (themeColor && themeColor.key) {
    less_change(themeColor.key, hideMessage.close());
  } else {
    less_change(null, hideMessage.close(), {
      "@primaryColor": themeColor.primaryColor,
      "@primaryColorHover": themeColor.primaryColorHover,
      "@isDark": themeColor.isDark,
      "@linear-gradient": themeColor.linearGradient
    });
  }
};

const Theme = {
  state: {
    themeColor: themeColor || {},
    pageTemplate: getCurrentTemplate()
  },
  getters: {
    themeColor: state => state.themeColor,
    pageTemplate: state => state.pageTemplate,
    isInternational: (state, getters) => {
      const { index } = getters.pageTemplate;
      return index === 3 || index === 4;
    }
  },
  mutations: {
    [SET_THEME_COLOR]: (state, data) => {
      data.version = process.env.VERSION;
      if (data.primaryColor) {
        localStorage.setItem("themeColor", JSON.stringify(data));
      } else {
        localStorage.removeItem("themeColor");
      }

      state.themeColor = data;
    },
    [SET_PAGE_TEMPLATE]: (state, data) => {
      data.version = process.env.VERSION;
      if (data.primaryColor) {
        localStorage.setItem("themeColor", JSON.stringify(data));
      } else {
        localStorage.removeItem("themeColor");
      }
      state.pageTemplate = data;
      state.themeColor = data;
    }
  },
  actions: {
    changTheme({ commit, state }, playload) {
      const { themeColor } = playload;
      if (state.themeColor.primaryColor !== themeColor.primaryColor) {
        let a = JSON.parse(localStorage.getItem("themeColor")) || {};
        a = {
          ...a,
          ...themeColor
        };
        // updateTheme(a);
        const hideMessage = Toast("正在加载...");
        less_change(null, hideMessage.close(), {
          "@primaryColor": a.primaryColor,
          "@primaryColorHover": a.primaryColorHover,
          "@isDark": a.isDark,
          "@linear-gradient": a.linearGradient
        });
        commit("SET_THEME_COLOR", a);
      }
    },
    changTemplate({ commit, state }, playload) {
      const { pageTemplate, keep = false } = playload;
      let a = JSON.parse(localStorage.getItem("themeColor")) || {};
      let c = {};
      if (keep) {
        c = {
          ...pageTemplate,
          primaryName: a.primaryName || pageTemplate.primaryName,
          primaryColor: a.primaryColor || pageTemplate.primaryColor,
          linearGradient: a.linearGradient || pageTemplate.linearGradient,
          isDark: a.isDark || pageTemplate.isDark
        };
      } else {
        c = {
          ...pageTemplate
        };
      }

      const hideMessage = Toast("正在加载...");

      // if (state.pageTemplate.index !== pageTemplate.index) {
      less_change(themeColor.key, hideMessage.close());
      less_change(null, hideMessage.close(), {
        "@primaryColor": c.primaryColor,
        "@primaryColorHover": c.primaryColorHover,
        "@isDark": c.isDark,
        "@linear-gradient": c.linearGradient
      });
      // updateTheme(c)
      commit("SET_PAGE_TEMPLATE", c);
      // }
    }
  }
};

export default Theme;
